import { Controller } from "@hotwired/stimulus"
import { Toast } from "bootstrap"

// Connects to data-controller="toast"
export default class extends Controller {
  connect() {
    const testEnv = document.body.dataset.env === "test"
    const toast = new Toast(this.element, {
      animation: !testEnv,
      autohide: true,
      delay: 5000
    })
    toast.show()
  }
}
